import { FC } from "react";
import { FormikProps } from "formik";
import { priceFields } from "../../../../validation-schemas/PriceSchema";
import { getMetaParameterValue } from "../../../../validation-schemas/SchemaFactory";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Currency } from "../../../../domain/enums/CurrencyEnum";

interface PriceInputProps {
    form: FormikProps<any>;
    name: string;
    className: string;
}

const PriceInput: FC<PriceInputProps> = (props) => {
    const { t } = useTranslation();
    const amountKey = `${props.name}.amount`;
    const currencyKey = `${props.name}.currency`;

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.form.setFieldTouched(amountKey, true);
        props.form.setFieldValue(currencyKey, Currency.UAH); // TODO
        props.form.handleChange(event);
    };

    return (
        <input
            type={priceFields.amount.type}
            defaultValue={priceFields.amount.initial as number}
            value={_.get(props.form.values, amountKey)}
            min={getMetaParameterValue(priceFields.amount, "min")}
            max={getMetaParameterValue(priceFields.amount, "max")}
            name={amountKey}
            placeholder={t(priceFields.amount.placeholderKey)}
            onChange={handleInputChange}
            className={`input input-spinner-hidden ${props.className}`}
        />
    );
};

export default PriceInput;
